import { Omit, WithEffect } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { Attachment } from './attachment.entity';

// WithEffect instead of top-level .refine() on AttachmentSchema: .refine() turns ZodObject into
// ZodEffects, breaking Omit/Partial/Pick on the base entity. Validation lives at the DTO level only.
export class CreateAttachmentDto extends WithEffect(Omit(Attachment, [...BaseEntityFieldsArray]), {
    check: (data) => !!(data.file || data.url),
    message: {
        message: 'Either file or url must be provided',
        path: ['file'],
    },
}) {}
